export default [
  {
    /**
     * 	用户产品列表
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'queryUserProductList',
    method: 'post',
    url: '/finhub/front/product/queryUserProductList',
  },
  {
    /**
     * 	用户产品详情
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'queryUserProductDetail',
    method: 'post',
    url: '/finhub/front/product/queryUserProductDetail',
  },
]
